import { appServices } from "api/schoolApp/services";

export const checkUserOnline = (user_id) => {
    if(user_id){
        appServices.checkUserOnline(user_id)
    }
}